import Cookies from 'js-cookie';
import FetchServicesCustomErrors from './BaseFetch';

export function FetchEndpointToGetSessionId() {
  const endpoint = `${import.meta.env.REACT_APP_API_SERVER}/create-session`;

  return FetchServicesCustomErrors({ endpoint, method: 'POST' });
}

export function getSessionCookie() {
  const apurataSessionId = Cookies.get('apurataSessionId');
  if (!apurataSessionId) {
    FetchEndpointToGetSessionId().then(
      () => {
        console.log(apurataSessionId);
        Cookies.set('apurataSessionId', apurataSessionId);
      },
      (err) => {
        console.log('Error get SessionId', err);
      },
    );
  }
  return apurataSessionId;
}
